import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, Document as RichTextDocument } from "@contentful/rich-text-types";
import { useFootnoteContext } from "@utils/FootnoteContext";

export const TextBlockRichText = ({ json }: { json: unknown }) => {
  const { getNumber } = useFootnoteContext();
  return (
    <>
      {documentToReactComponents(json as RichTextDocument, {
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
          [INLINES.EMBEDDED_ENTRY]: (node) => {
            const id = node.data?.target?.sys?.id as string | undefined;
            if (!id) return null;
            const number = getNumber(id);
            if (number === null) return null;
            return <sup className="text-[0.6em] leading-none">{number}</sup>;
          },
        },
      })}
    </>
  );
};
